import React from 'react';
import { useNavigate } from 'react-router-dom';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
// Icons
import iconError from '../../../assets/icons/icon_circle-error.svg';

function ModalErrorPost({ openModals, onHandleClose, clearForm }) {
    const navigate = useNavigate();

    const handleNavigate = () => {
        clearForm();
        navigate('/prestador/dashboard');
    };

    return (
        <SmallModalContainer open={openModals}
            onClose={onHandleClose}>
            <Box display="flex" flexDirection="column" gap={"1rem"}>
                <Box
                    component="img"
                    sx={{ width: "54px", height: "54px" }}
                    alt="img not found"
                    src={iconError}
                />
                <Typography variant="h1">No pudimos enviar tu solicitud</Typography>
                <Typography variant="h4" component="p">Intentalo nuevamente más tarde.</Typography>
                <Box display="flex" gap={"1rem"} marginTop="1.5rem">
                    <Button
                        onClick={() => handleNavigate()}
                        variant="contained"
                        sx={{ height: "48px", borderRadius: "16px", width: "100%" }}>
                        <Typography variant="cta" component="span"
                        >Volver al inicio
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </SmallModalContainer>
    );
}

export default ModalErrorPost;